import type { JSX } from 'react';

import HealthLayout from '@/components/layouts/health-layout';
import ThemeLayout from '@/components/layouts/theme-layout';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';

import { AppProvider } from './provider';
import { AppRouter } from './router';

export const App = (): JSX.Element => {
  return (
    <AppProvider>
      <TooltipProvider>
        <HealthLayout>
          <ThemeLayout>
            <AppRouter />
          </ThemeLayout>
        </HealthLayout>
      </TooltipProvider>
      <Toaster />
    </AppProvider>
  );
};
